module.exports = __webpack_public_path__ + "static/ysu-web-1-8e4db2faa036fd9b60e7ae466a40c8ca.jpg";